// card-picker.js
class DeployerCardPicker extends HTMLElement {
  constructor() {
    super();
    this.data = this.querySelector('[name="popin-atc-data"]');
    this.colorPickers = this.querySelector('td-color-picker');
    this.quantityPicker = this.querySelector('td-quantity-picker');
    this.buttonAddToCart = this.querySelector('.deployer-atc-button');
    this.isUpsell = this.querySelector('button[name="toggle-is-upsell"]');
    this.productVariants = document.querySelectorAll('.product-variants--hidden .product-variant');
    this.defaultProduct = this.buttonAddToCart.dataset.id;
    this.items = [
      {
        id: this.isUpsell.dataset.upsell == 'true' ? this.buttonAddToCart.dataset.idWithUpsell : this.buttonAddToCart.dataset.id,
        quantity: 1,
      },
    ];
    this.itemsBackup = [];
  }

  connectedCallback() {
    this.listenEvents();
    this.initUpsell();
    this.initPrice();
  }

  listenEvents() {
    document.addEventListener('td:colorChanged', (event) => {
      this.onColorChanged(event);
    });
    document.addEventListener('td:quantityChanged', (event) => {
      this.onQuantityChanged(event.detail.quantity);
      this.onPriceChanged(event.detail.price);
      this.onUpsellPriceChanged(event.detail.promo);
    });
    document.addEventListener('td:upsellChanged', (event) => {
      this.onUpsellChanged(event.detail);
    });

    this.isUpsell.addEventListener('click', this.onToggleUpsell);
    this.buttonAddToCart.addEventListener('click', this.addToCart.bind(this));
  }

  initUpsell() {
    const upsellContainer = this.querySelector('.swiper-slide-upsell-container');
    if (!upsellContainer.classList.contains('hidden-all')) {
      let priceWith = parseFloat(this.data.querySelector(`[data-is-upsell="true"]`).dataset.price);
      let priceWithout = parseFloat(this.data.querySelector(`[data-is-upsell="false"]`).dataset.price);
      upsellContainer.querySelector('.upsell__price').textContent = `(${parseFloat(priceWith - priceWithout).toFixed(2)}€)`;
    }
  }

  initPrice() {
    const atcPrice = document.querySelector('#atc-button-price');
    atcPrice.textContent = this.data.querySelector(`[data-is-upsell="${this.isUpsell.dataset.upsell}"]`).dataset.price;
  }

  isDeployerColorAvailable(action = 'color', detail, isUpsell) {
    const color = detail.color.value;
    const upsell = detail.index == 0 ? isUpsell.dataset.upsell : false;
    const data = this.data.querySelector(`[data-color="${color}"][data-is-upsell="${upsell}"]`);
    const colorPickerInput = this.querySelector('td-color-picker input');

    if (data === undefined || data === null) {
      if (action === 'color') {
        this.buttonAddToCart.dataset.isUpsell = 'false';
        this.items[detail.index].id = this.data.querySelector(`[data-color="${color}"][data-is-upsell="false"]`).value;
        this.isUpsell.setAttribute('disabled', true);
        this.isUpsell.classList.remove('upsell__unit--checked');
      }
      if (action === 'upsell') {
        this.buttonAddToCart.dataset.isUpsell = 'true';
        colorPickerInput.classList.remove('active');
      }
    } else {
      this.buttonAddToCart.dataset.id = data.value;
      this.items[detail.index].id = data.value;
      this.buttonAddToCart.removeAttribute('disabled');
      this.isUpsell.removeAttribute('disabled');
      colorPickerInput.removeAttribute('disabled');
    }
  }

  onColorChanged(event) {
    this.isDeployerColorAvailable('color', event.detail, this.isUpsell);
  }

  onQuantityChanged(quantity) {
    if (quantity > this.items.length) {
      const elementsToAdd = quantity - this.items.length;
      for (let i = 0; i < elementsToAdd; i++) {
        if (this.itemsBackup[0]) {
          this.items.push(this.itemsBackup[0]);
          this.itemsBackup.shift();
        } else {
          this.items.push({
            id: this.defaultProduct,
            quantity: 1,
          });
        }
      }
    } else if (quantity < this.items.length) {
      const elementsToRemove = this.items.length - quantity;
      for (let i = this.items.length - 1; i >= this.items.length - elementsToRemove; i--) {
        this.itemsBackup.unshift(this.items[i]);
      }
      this.items.splice(quantity, elementsToRemove);
    }
  }

  onPriceChanged(price) {
    const atcPrice = document.querySelector('#atc-button-price');
    const formatedPrice = parseFloat(price / 100).toFixed(2) + '€';
    atcPrice.textContent = formatedPrice;
  }

  onUpsellPriceChanged(promo) {
    const upsellContainer = this.querySelector('.swiper-slide-upsell-container');
    if (!upsellContainer.classList.contains('hidden-all')) {
      let priceWith = parseFloat(this.data.querySelector(`[data-is-upsell="true"]`).dataset.price);
      let priceWithout = parseFloat(this.data.querySelector(`[data-is-upsell="false"]`).dataset.price);
      upsellContainer.querySelector('.upsell__price').textContent = `(${(
        (parseFloat(priceWith - priceWithout) * (100 - parseFloat(promo))) /
        100
      ).toFixed(2)}€)`;
    }
  }

  onUpsellChanged(detail) {
    const currentColor = this.data.querySelector(`option[value="${this.items[0].id}"]`).dataset.color;
    this.items[0].id = this.data.querySelector(`[data-color="${currentColor}"][data-is-upsell="${detail.upsell}"]`).value;
  }

  onToggleUpsell(event) {
    event.preventDefault();
    this.isUpsell = document.querySelector('button[name="toggle-is-upsell"]');
    this.isUpsell.classList.contains('upsell__unit--checked')
      ? this.isUpsell.classList.remove('upsell__unit--checked')
      : this.isUpsell.classList.add('upsell__unit--checked');
    this.isUpsell.dataset.upsell = this.isUpsell.dataset.upsell == 'true' ? 'false' : 'true';

    const atcPrice = document.querySelector('#atc-button-price');
    const upsellPrice = this.isUpsell.querySelector('.upsell__price').textContent.replace('(', '').replace(')', '');
    const newPrice =
      parseFloat(atcPrice.textContent.replace(',', '.')) +
      (this.isUpsell.dataset.upsell == 'true' ? parseFloat(upsellPrice.replace(',', '.')) : parseFloat(upsellPrice.replace(',', '.')) * -1);
    atcPrice.textContent = newPrice.toFixed(2) + '€';

    document.dispatchEvent(
      new CustomEvent('td:upsellChanged', {
        detail: {
          upsell: this.isUpsell.dataset.upsell,
        },
      }),
    );
  }

  onSelectedButton(button) {
    const globalThis = this;
    const quantity = button.dataset.packQty;

    globalThis.onQuantityChanged(quantity);
    button.setAttribute('data-selected', 'true');
  }

  onDeselectedButton(button) {
    button.removeAttribute('data-selected');
  }

  addToCart() {
    let idQuantities = {};
    let totalQuantity = 0;

    this.items.forEach((item) => {
      const { id, quantity } = item;
      totalQuantity += quantity;
      if (idQuantities[id] === undefined) {
        idQuantities[id] = quantity;
      } else {
        idQuantities[id] += quantity;
      }
    });

    let formattedItems = Object.keys(idQuantities).map((id) => ({
      id: parseInt(id),
      quantity: idQuantities[id],
    }));

    const fetchedData = {
      items: formattedItems.reverse(),
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(fetchedData),
    })
      .then(async (response) => {
        const cartUpdatedEvent = new CustomEvent('cart:updated', {
          bubbles: !0,
          detail: {
            cart: {
              item_count: totalQuantity,
            },
          },
        });

        document.documentElement.dispatchEvent(cartUpdatedEvent);

        const cartRefreshEvent = new CustomEvent('cart:refresh', {
          bubbles: !0,
          detail: {
            cart: {
              item_count: totalQuantity,
            },
            openMiniCart: !0,
          },
        });

        document.documentElement.dispatchEvent(cartRefreshEvent);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

window.customElements.define('deployer-card-picker', DeployerCardPicker);

class DeployerQuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.colorPickers = document.querySelectorAll('td-color-picker');
    this.upsellPrice = 0;
    this.isUpsell = document.querySelector('button[name="toggle-is-upsell"]').dataset.upsell;
    if (this.isUpsell == 'true')
      this.upsellPrice = parseFloat(document.querySelector('.upsell__price').textContent.replace('(', '').replace(')', '')) * 100;
    document.addEventListener('td:upsellChanged', (event) => {
      this.onUpsellChanged(event.detail);
    });
  }

  connectedCallback() {
    this.querySelectorAll('button').forEach((button, generalIndex) => {
      button.addEventListener('click', (element) => {
        this.querySelectorAll('button').forEach((button, childrenIndex) => {
          if (generalIndex === childrenIndex) {
            this.onSelectedButton(button);
          } else {
            this.onDeselectedButton(button);
          }
        });
      });
    });
  }

  onUpsellChanged(detail) {
    this.isUpsell = detail.upsell;
    if (detail.upsell == 'true')
      this.upsellPrice = parseFloat(document.querySelector('.upsell__price').textContent.replace('(', '').replace(')', '')) * 100;
    else this.upsellPrice = 0;
  }

  onSelectedButton(button) {
    button.setAttribute('data-selected', 'true');
    document.dispatchEvent(
      new CustomEvent('td:quantityChanged', {
        detail: {
          quantity: button.dataset.packQty,
          id: button.dataset.packId,
          price: parseFloat(button.dataset.packPrice) + (this.upsellPrice * (100 - parseFloat(button.dataset.packPromo))) / 100,
          promo: button.dataset.packPromo,
        },
      }),
    );
  }

  onDeselectedButton(button) {
    button.removeAttribute('data-selected');
  }
}

window.customElements.define('td-quantity-picker', DeployerQuantityPicker);

// color-picker.js
class DeployerColorPicker extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.td--color-swatch-container');
    this.data = document.querySelector('[name="popin-atc-data"]');
    this.isUpsell = document.querySelector('button[name="toggle-is-upsell"]');
    this.inputs = this.querySelectorAll('input');
    this.updateAvailableColors();
    this.initCheckedElement();
  }

  connectedCallback() {
    const globalThis = this;
    this.imgElement = this.querySelector('.td--color-swatch-image');
    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach((input) => {
      input.addEventListener('change', function () {
        globalThis.inputChanged(input);
        document.dispatchEvent(
          new CustomEvent('td:colorChanged', {
            detail: {
              color: input,
              index: input.dataset.packIndex,
            },
          }),
        );
      });
    });
    document.addEventListener('td:quantityChanged', (e) => this.onQuantityChanged(e));
    document.addEventListener('td:upsellChanged', (e) => {
      this.updateAvailableColors();
      this.onUpsellChanged(e);
    });
  }

  updateAvailableColors() {
    let upsell = this.isUpsell.dataset.upsell;
    this.inputs.forEach((input) => {
      if (input.dataset.packIndex == 0) {
        if (!this.data.querySelector(`[data-color="${input.value}"][data-is-upsell="${upsell}"]`)) input.setAttribute('dont-exist', 'true');
        else input.removeAttribute('dont-exist');
      } else {
        if (!this.data.querySelector(`[data-color="${input.value}"][data-is-upsell="false"]`)) input.setAttribute('dont-exist', 'true');
        else input.removeAttribute('dont-exist');
      }
    });
  }

  initCheckedElement() {
    for (let i = 0; i < this.inputs.length; i++) {
      const input = this.inputs[i];
      if (!input.getAttribute('dont-exist')) {
        input.classList.add('active');
        input.checked = true;
        break;
      }
    }
  }

  inputChanged(currentInput) {
    let upsell = this.isUpsell.dataset.upsell;
    this.inputs.forEach((input) => {
      if (input.dataset.packIndex > 0) upsell = false;
      if (input === currentInput) {
        input.classList.add('active');
        input.checked = true;
      } else {
        input.classList.remove('active');
        input.checked = false;
      }
    });
    this.imgElement.src = this.data.querySelector(`[data-color="${currentInput.value}"][data-is-upsell="${upsell}"]`).dataset.image;
  }

  onQuantityChanged(event) {
    const colorSwatches = document.querySelectorAll('.td--color-swatch-container');
    const qty = event.detail.quantity;

    colorSwatches.forEach((colorSwatch) => {
      var packQty = parseInt(colorSwatch.getAttribute('data-pack-qty'));

      if (packQty <= qty) {
        colorSwatch.classList.remove('disabled');
      } else {
        colorSwatch.classList.add('disabled');
      }
    });
  }

  onUpsellChanged(event) {
    if (this.container.dataset.packQty == 1) {
      const currentInput = this.querySelector('.active');
      let currentColor = currentInput.value;
      if (currentInput.getAttribute('dont-exist')) {
        for (let i = 0; i < this.inputs.length; i++) {
          const input = this.inputs[i];
          if (!input.getAttribute('dont-exist')) {
            currentColor = input.value;
            this.inputChanged(input);
            document.dispatchEvent(
              new CustomEvent('td:colorChanged', {
                detail: {
                  color: input,
                  index: input.dataset.packIndex,
                },
              }),
            );
            break;
          }
        }
      }
      this.imgElement.src = this.data.querySelector(
        `[data-color="${currentColor}"][data-is-upsell="${event.detail.upsell}"]`,
      ).dataset.image;
    }
  }
}

window.customElements.define('td-color-picker', DeployerColorPicker);

function updateKlaviyoButton(variant) {
  const klaviyoButton = document.querySelector('.klaviyo-bis-trigger');

  if (!klaviyoButton) return;
  if (!variant) return;

  if (variant && variant.available === true) {
    klaviyoButton.style.display = 'none';
  } else {
    klaviyoButton.style.display = 'block';
  }
}

document.addEventListener('deployer:update-klaviyo', function (event) {
  updateKlaviyoButton(event.detail.variant);
});

if (!window.customElements.get('td-progress-bar')) {
  window.customElements.define(
    'td-progress-bar',
    class TDProgressBar extends HTMLElement {
      constructor() {
        super();

        (this.template = this.querySelector('template[data-items]').content),
          (this.content = {
            text_before: this.template.querySelector('[data-text-before]').innerText,
            text_after: this.template.querySelector('[data-text-after]').innerText,
            text_final: this.template.querySelector('[data-text-final]').innerText,
          });
      }

      connectedCallback() {
        // document.addEventListener(
        //     'cart:updated',
        //     this.onCartEvent.bind(this)
        //   );
        // document.addEventListener(
        //     'cart:refresh',
        //     this.onCartEvent.bind(this)
        //   );
      }

      onCartEvent(event) {
        const cart = event.detail.cart;

        this.updateBars(cart.item_count);
        this.updateContent(cart.item_count);
      }

      updateBars(cartItemsCount) {
        const bars = this.querySelectorAll('td-progress');
        const currentStep = cartItemsCount;

        for (let i = 0; i < bars.length; i++) {
          const bar = bars[i];
          const barValue = parseInt(bar.getAttribute('data-step'));
          if (barValue <= currentStep) {
            bar.classList.add('active');
          } else {
            bar.classList.remove('active');
          }
        }
      }

      get latestActiveStep() {
        const bars = this.querySelectorAll('td-progress');
        let latestActiveStep = 0;

        for (let i = 0; i < bars.length; i++) {
          const bar = bars[i];
          const barValue = parseInt(bar.getAttribute('data-step'));
          if (bar.classList.contains('active') && barValue >= latestActiveStep) {
            latestActiveStep = barValue;
          }
        }

        return latestActiveStep;
      }

      get nextOneToLatestActiveStep() {
        const bars = this.querySelectorAll('td-progress');
        let latestActiveStep = 0;
        let latestActiveIndex = 0;

        for (let i = 0; i < bars.length; i++) {
          const bar = bars[i];
          const barValue = parseInt(bar.getAttribute('data-step'));
          if (bar.classList.contains('active') && barValue >= latestActiveStep) {
            latestActiveStep = barValue;
            latestActiveIndex = i;
          }
        }

        if (bars[latestActiveIndex + 1] !== undefined) return parseInt(bars[latestActiveIndex + 1].getAttribute('data-step'));

        return parseInt(bars[latestActiveIndex].getAttribute('data-step'));
      }

      updateContent(cartItemsCount) {
        const label = this.querySelector('.td-progress__label');

        label.innerHTML = `
                ${this.content.text_before} ${parseInt(this.nextOneToLatestActiveStep) - cartItemsCount} ${this.content.text_after}`;

        if (this.nextOneToLatestActiveStep === this.latestActiveStep) {
          label.innerHTML = this.content.text_final;
        }
      }
    },
  );
}